import type { SVGProps } from 'react';
import { useId } from 'react';

/**
 * The PIPE brand mark (monogram): a "P" whose bowl is an open pipe-bore, on a
 * blue gradient rounded square — the same mark as the app favicon. Drop-in
 * replacement for the upstream AFFiNE `Logo1Icon` glyph; sizes to `1em` by
 * default so it follows `font-size`, and forwards `className`/`style`/`width`/
 * `height` like an icon component.
 */
export const PipeLogoIcon = ({
  width,
  height,
  ...props
}: SVGProps<SVGSVGElement>) => {
  // Unique per-instance gradient id so multiple logos on one page don't collide.
  const gradientId = useId();
  return (
    <svg
      width={width ?? '1em'}
      height={height ?? '1em'}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="PIPE"
      {...props}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="64"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#38BDF8" />
          <stop offset="1" stopColor="#2563EB" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill={`url(#${gradientId})`} />
      {/* "P" monogram whose bowl is an open pipe-bore */}
      <rect x="18" y="13" width="10" height="38" rx="5" fill="#ffffff" />
      <circle cx="31" cy="24" r="13" fill="#ffffff" />
      <circle cx="31" cy="24" r="5.5" fill={`url(#${gradientId})`} />
    </svg>
  );
};
